import Flamingo1 from '../../../media/Residentials/Flamingo/Flamingo.webp'
import Flamingo2 from '../../../media/Residentials/Flamingo/Flamingo.webp'


const Flamingoimages =[
Flamingo1,Flamingo2
]

export default Flamingoimages;